module.exports = __webpack_public_path__ + "static/media/marker-arrow-up-h19.2d2e6a2d.svg";